var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeason(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / season") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-season"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: 0,
    transform: "translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 45,
    transform: "translate(30.000000, 30.500000) rotate(45.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 90,
    transform: "translate(30.000000, 30.500000) rotate(90.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 135,
    transform: "translate(30.000000, 30.500000) rotate(135.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 180,
    transform: "translate(30.000000, 30.500000) rotate(180.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 225,
    transform: "translate(30.000000, 30.500000) rotate(225.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 270,
    transform: "translate(30.000000, 30.500000) rotate(270.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("g", {
    id: 315,
    transform: "translate(30.000000, 30.500000) rotate(315.000000) translate(-30.000000, -30.500000) translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2514974,5.3659342 C19.6155872,6.17132667 19.0152477,6.21489648 18.072886,6.77638534 C17.8915223,6.88444752 17.6488503,7.08126508 17.3448698,7.36683803 C17.2740393,6.91949921 17.1855288,6.61841059 17.0793381,6.46357217 C16.8779197,6.1698805 16.5294345,5.76266501 16.4290868,5.29398757 C16.3352834,4.85587537 16.5345192,4.12078251 17.0267942,3.08870899 C16.1936702,3.70967546 15.6124196,4.32508492 15.2830426,4.93493735 C14.9536655,5.54478979 14.6926513,6.38008785 14.5,7.44083154 L17.2737022,7.8133342 L19.6401477,9.08528977 C19.6822466,8.69030929 19.742083,8.43777161 19.819657,8.32767672 C20.5907639,7.23330253 21.2382227,6.83350879 21.4287949,5.76266501 C21.5606045,5.02201382 21.3861276,3.93445881 20.9053641,2.5 C20.9028864,3.86167099 20.6849308,4.81698239 20.2514974,5.3659342 Z",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 15,
    cy: 14.5,
    r: 14.125
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 30,
    cy: 30.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    fill: "#000000",
    cx: 30,
    cy: 30.5,
    r: 6.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "award---sorounding-icon",
    transform: "translate(12.000000, 12.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    rx: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeason);
export default __webpack_public_path__ + "static/media/Season.43003b31b3a5c4ca12d4237255bb9e41.svg";
export { ForwardRef as ReactComponent };